// The customer-facing origin used to build shareable/scannable links (QR codes, etc.).
// window.location.origin resolves correctly once deployed (it's whatever domain the page
// is actually served from), but it's fragile for this use case: if a QR is generated while
// someone's on localhost, or on a Vercel preview-branch URL instead of the real production
// domain, the QR bakes in an origin nobody else can reach. REACT_APP_PUBLIC_URL lets
// production pin this explicitly instead of depending on which origin happened to generate it.
export function publicUrl(path) {
  const base = (process.env.REACT_APP_PUBLIC_URL || window.location.origin).replace(/\/$/, "");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}
